export default __webpack_public_path__ + "static/media/bear.576d4e87.png";